import Swal from 'sweetalert2'
import { textHtml } from './textHtml'
import {
  makeAjaxCall,
  handleDataOfDelay, 
  prepareDropdownLists,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
} from '../../utils/functions'
import { lang } from '../../assets/lang'
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
var base_url = window.xitFlowBuilderData.base_url
const media_type = instagram_bot_addon ? 'ig' : 'fb'

export const textModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.text_modal_title,
    html: textHtml,

    willOpen: () => {
      const customFieldVariableData = {
        url: base_url + 'visual_flow_builder/get_custom_field_variable_dropdown/' + media_type,
      }

      makeAjaxCall(function(response) {
        const optionsArray = response.custom_field_variable_dropdown_array || []
        const html = prepareDropdownLists(optionsArray)
        $('.text-text-custom-variable .dropdown-menu').html(html)  
      }, customFieldVariableData)
 
      $('.lead_first_name').on('click', function() {
        var textAreaTxt = $('.emojionearea-editor').html();

        var lastIndex = textAreaTxt.lastIndexOf("<br>");   
        var lastTag = textAreaTxt.substr(textAreaTxt.length - 4); 
        lastTag=lastTag.trim(lastTag);

        if(lastTag=="<br>")
        textAreaTxt = textAreaTxt.substring(0, lastIndex); 

        var txtToAdd = " #LEAD_USER_FIRST_NAME# ";
        var new_text = textAreaTxt + txtToAdd;
        $('.emojionearea-editor').html(new_text);
        $('.emojionearea-editor').trigger('blur');
      });

      $('.lead_last_name').on('click', function() {
        var textAreaTxt = $('.emojionearea-editor').html();
        
        var lastIndex = textAreaTxt.lastIndexOf("<br>");   
        var lastTag = textAreaTxt.substr(textAreaTxt.length - 4); 
        lastTag=lastTag.trim(lastTag);

        if(lastTag=="<br>")
          textAreaTxt = textAreaTxt.substring(0, lastIndex); 
            
        var txtToAdd = ! instagram_bot_addon ? " #LEAD_USER_LAST_NAME# " : " #LEAD_FULL_NAME# ";
        var new_text = textAreaTxt + txtToAdd;
        $('.emojionearea-editor').html(new_text);
        $('.emojionearea-editor').trigger('blur');
      });

      $('.dropdown-menu').on('click', '.dropdown-item', function(event) {
        const selectedText = event.target.innerText

        var textAreaTxt = $('.emojionearea-editor').html()
        
        var lastIndex = textAreaTxt.lastIndexOf("<br>");   
        var lastTag = textAreaTxt.substr(textAreaTxt.length - 4);
        lastTag=lastTag.trim(lastTag)

        if(lastTag=="<br>")
          textAreaTxt = textAreaTxt.substring(0, lastIndex)
        
        var txtToAdd = " #" + selectedText + "# "
        var new_text = textAreaTxt + txtToAdd;
        $('.emojionearea-editor').html(new_text);
        $('.emojionearea-editor').trigger('blur');
      });

      $('#text-text-message').html(oldData.textMessage || '')
      // $('.emojionearea-editor').html(oldData.textMessage || '')

      handleOldDataOfDelay(oldData)

      $("#text-text-message").emojioneArea({
        autocomplete: false,
        pickerPosition: "bottom"
      })

      $('[data-toggle="tooltip"]').tooltip()  
      $('[data-toggle-second="tooltip"]').tooltip()  
    },

    preConfirm: () => {
      const textMessage = $('#text-text-message').val()

      if (! textMessage) {
        Swal.showValidationMessage(lang.text_modal_msg_reply_message)
      }
      
      const delayData = handleDataOfDelay()

      return { 
        textMessage,
        ...delayData
      }
    },

    didDestroy: () => {
      const tooltip = $('[data-toggle="tooltip"]')
      if (tooltip) {
        $('[data-toggle="tooltip"]').tooltip('dispose')
      }
    },
  })
}